import aiMusicGeneratorApi from 'services/api/aiMusicGenerator/aiMusicGeneratorApi';
import { BundleType, VegaBundle } from 'services/store/ai/types';
import AdvancedBundle from './AdvancedBundle';
import TextBundle from './TextBundle';

type PropsTypes = {
  bundle: VegaBundle;
};

const POLLING_INTERVAL = 5000;

const BundleContainer = ({ bundle }: PropsTypes) => {
  const { id, isFinished } = bundle;

  aiMusicGeneratorApi.useGetBundleByIdQuery(id, {
    pollingInterval: POLLING_INTERVAL,
    skip: isFinished,
  });

  if (bundle.bundleType === BundleType.TEXT2MUSIC) {
    return <TextBundle bundle={bundle} />;
  }

  if (bundle.bundleType === BundleType.ADVANCED) {
    return <AdvancedBundle bundle={bundle} />;
  }

  return null;
};

export default BundleContainer;
